import React,{useState,useEffect} from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { FavoriteBorderOutlined, Favorite } from '@mui/icons-material'
import { useDispatch } from "react-redux";
import { addCart } from "../redux/action";
import { Url } from '../services/Constants';
import toast from 'react-hot-toast';
import axios from 'axios';
import { Link, useNavigate } from "react-router-dom";
import { GetUserRole } from '../services/UserRole';
import { setHeader } from '../services/Headers';
import {Swiper, SwiperSlide } from 'swiper/react';
import { register } from 'swiper/element/bundle';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Getauth } from '../services/Auth';
import { addFavorite, removeFavorite } from '../redux/action';
import { Oval } from 'react-loader-spinner';
import {CartUpdate} from "../services/CartUpdate"
import HomeContent from '../homecontent/HomeContent';





register()

export default function Home() {

  const [usertype, setUserType] = useState(false);
  const [products, setProducts] = useState([])
  const [categories, setCategories] = useState([])
  const [favoriteProducts, setFavoriteProducts] = useState([]);
  const [isSeller,setIsSeller] = useState(false)
  const userRole = GetUserRole();
  const navigate = useNavigate();
  const [recentBuyers, setRecentBuyers] = useState([])
  const [recentOrders, setRecentOrders] = useState([])
  const [recentProductsData, setRecentProductsData] = useState([])
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState();
  const [quantity, setQuantity] =  useState(1)
  



  const dispatch = useDispatch();

  useEffect(() => {
    const fetchFavoriteProducts = async () => {
      if (userRole === "buyer") {
        try {
          const response = await axios.get(`${Url}/buyer/products/favourite_products`, setHeader());
          const favoriteIds = response.data.response_data.products.map(product => product.id);
          setFavoriteProducts(favoriteIds);
        } catch (error) {
          console.error("Error fetching favorite products:", error);
        }
      }
    };
    fetchFavoriteProducts();
  },[])

  useEffect(()=>{

    const getProducts = async()=>{
      try {
        let result;
        if(userRole === "seller"){
           result = await axios.get(`${Url}/seller/products` ,setHeader())
           setIsSeller(!isSeller)
        }else if(userRole === 'buyer'){
           result = await axios.get(`${Url}/buyer/products`, setHeader())
        }else{
           result = await axios.get(`${Url}/buyer/products`)
        }
        setProducts(result.data.response_data.products)
        // console.log(result.data.response_data.products[1].product_images[0].image)
      } catch (error) {
        console.log(error)
      } 

    }

    getProducts()
  },[])

  useEffect(()=>{
    if(recentBuyers.length>0 || recentOrders.length>0 || recentProductsData.length>0){
    setLoading(false)
    }
  },[userId])


  useEffect(()=>{

    const getProducts = async()=>{
      try {
        const result = await axios.get(`${Url}/categories`)
        setCategories(result.data.response_data.categories)
      } catch (error) {
        console.log(error)
      } 

    }

    getProducts()
  },[isSeller])

  useEffect(() => {
    if(userRole === "seller"){
      setIsSeller(true)
    }
  },[])

  const handleProductClick = async (productId) => {
    const productDetailsPath = userRole === "seller"
      ? `${Url}/seller/products/${productId}`
      : `${Url}/buyer/products/${productId}`;

    try {
      const response = await axios.get(productDetailsPath);

      navigate(`/product-detail/${productId}`);
    } catch (error) {
      console.error("Error fetching product details:", error);
    }
  };

  const handleFavoritesClick = async (productId) => {
    if(Getauth()){
       try {
      if (userRole === "buyer") {
        const isFavorite = favoriteProducts.includes(productId);
        const response = await axios.post(`${Url}/buyer/products/${productId}/favourite_unfavourite?is_favourite=${!isFavorite}`,{},setHeader());

        if (response.status === 200) {
          if (isFavorite) {
            dispatch(removeFavorite(productId));
            toast.success("Product removed from favorites!");
            setFavoriteProducts(favoriteProducts.filter(id => id !== productId));
          } else {
            dispatch(addFavorite(productId));
            toast.success("Product added to favorites!");
            setFavoriteProducts([...favoriteProducts, productId]);
          }
        }
      }
    } catch (error) {
      console.error("Error updating favorites:", error);
    }
  }else{
      toast.error("Please login to add favorite!")
  }

  };

  const roleHandle =()=>{
    setIsSeller(!isSeller)
  }

 
  useEffect(() => {

    const fetchRecentData = async () => {
      if (!isSeller) return;

      try {
        const [buyersResponse, ordersResponse, productsResponse] = await Promise.all([
          axios.get(`${Url}/seller/recent_buyers`, setHeader()),
          axios.get(`${Url}/seller/recent_orders`, setHeader()),
          axios.get(`${Url}/seller/products/recent_products`, setHeader())
        ]);
        setLoading(true);
        if(buyersResponse.data.response_code !== 200&& ordersResponse.data.response_code !== 200 && productsResponse.data.response_code !== 200){
          setLoading(false)
        }
        if(buyersResponse.data.response_code === 200){
          setRecentBuyers(buyersResponse.data.response_data.recent_buyers);
        }
        if(ordersResponse.data.response_code === 200){
          setRecentOrders(ordersResponse.data.response_data.recent_orders.slice(0, 4));
        }
        if(productsResponse.data.response_code === 200){
          setRecentProductsData(productsResponse.data.response_data.products.slice(0, 5));
        }
        setUserId(buyersResponse.data.response_code)
      } catch (error) {
        console.error("Error fetching recent data:", error);
      } 
    };

    

    fetchRecentData();
  }, [isSeller]);

  useEffect(()=>{
    if(recentBuyers && recentOrders && recentProductsData){
    }

  },[recentBuyers, recentOrders, recentProductsData])

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-GB', options).replace(',', '');
  };


  const addProduct = async (product) => {
    try {
        dispatch(addCart(product));
        CartUpdate();
        toast.success("Product added to cart.")
    } catch (error) {
        console.error('Error adding product to cart:', error);
        toast.error("Error adding product to cart!")
    }
  };


  const addtoCart = async(product)=>{
    if (product.product_variants[0].left_qty === 0) {
      toast.error("Product is out of stock!")
    }else{
      try {
        const result = await axios.get(`${Url}/buyer/products/check_available_quantity?product_variant_id=${product.product_variants[0].id}&quantity=${quantity}`)
        if(result.data.response_code===200){
          const data = {
            cart_id:"",
            quantity:quantity,
            seller_name:product.seller_name,
            product_name:product.name,
            product_image:product.product_images[0].image,
            category:product.category_name,
            product_variant_id:product.product_variants[0].id,
            stock_qty:product.product_variants[0].stock_qty,
            left_qty:product.product_variants[0].left_qty,
            price:product.product_variants[0].price,
            discounted_price:product.product_variants[0].discounted_price,
            gst:product.product_variants[0].gst,
            product_code:product.category_id,
            isOutOfStock:""
          }
          addProduct(data)
        }else{
          toast.error("Required quantity is not available!")
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

  
  return (
    <>

    <style>{`

			.banner-slider .swiper-button-prev:after,
			.banner-slider .swiper-button-next:after {
				color: #fff !important; /* White color for banner slider buttons */
				font-size: 20px !important; /* Font size for banner slider buttons */
			}

			/* Styles for the Tools Slider Navigation Buttons */
			.tools-slider .swiper-button-prev:after,
			.tools-slider .swiper-button-next:after {
				color: #000 !important; /* Black color for tools slider buttons */
				font-size: 16px !important; /* Font size for tools slider buttons */
			}

			.swiper-slide.slider-part {
				margin: 0 auto !important;
				width: 100% !important;
				height: 300px; /* Set a fixed height for the slides */
			}
			.swiper-image {
				width: 100%;
				height: 100%;
				object-fit: cover;
				border-radius: 17px;
			}
			.swiper {
				border-radius: 16px;
			}
      .swiper-button-prev{
       left:-2px !important;
       color: #000 !important;
      }
        .swiper-button-next{
       right:-2px !important;
       color: #000 !important;
      }
       .swiper-slide swiper-slide-prev swiperSlide py-2{
         padding-left: 500px !important;
       }
    `}
    </style>
			<div className="home-top">
				<Navbar className="" roleHandle={roleHandle} />
				<div className="relative h-screen bg-cover bg-center bg-no-repeat h-[569px]" style={{ backgroundImage: "url('assets/banners-image.jpg')" }}>
					<div className="absolute inset-0 bg-black opacity-50"></div>
					<div className="relative z-10 flex items-center justify-center h-full container mx-auto">
						<div className="flex flex-wrap justify-center items-center inner-banner px-4 md:px-0">
							<div className="w-full md:w-8/12 p-5">
								<h1 className="text-white text-4xl md:text-7xl font-bold text-center md:text-left">Find Best tools for<br /> you </h1>
								<p className="text-white mt-4 text-base md:text-lg text-center md:text-left">There are many variations of passages of Lorem Ipsum available, but the majority<br /> have suffered alteration in some form, </p>
							</div>
							<div className="w-[100%] md:w-3/12 relative bg-[#F2F2F2AB] rounded-2xl  md:mt-0">
								<Swiper
									modules={[Navigation, Autoplay]}
									navigation
									autoplay={{ delay: 3000 }}
									loop
									className="banner-slider"
								>
									{products.map((product, index) => (
										<SwiperSlide key={index} className='slider-part'>
											<img 
												src={product.product_images[0].image} 
												alt={`slide-${index}`} 
												className="swiper-image" 
											/>
										</SwiperSlide>
									))}
								</Swiper>
								<div className="btns flex justify-between absolute top-1/2 left-0 right-0 transform -translate-y-1/2">
									<div className="customNextBtn cursor-pointer"><i className="bi bi-chevron-left text-white text-2xl"></i></div>
									<div className="customPreviousBtn cursor-pointer"><i className="bi bi-chevron-right text-white text-2xl"></i></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div> 
      <div className="b">
        <section className="home-category mx-auto pt-5 mt-4 w-full">
          <div className="category-container w-[90%] mx-auto">
            <div className="justify-between items-center">
              <h2 className="text-xl font-medium">Category</h2>
              <hr className="my-4" />
            </div>
  
            <div className="flex justify-around w-full bg-gray-100 max-sm:flex-col py-2 max-sm:items-center max-sm:py-2">
              {loading ? (
                <p>Loading categories...</p>
              ) : categories.length > 0 ? (
                categories.map((category) => (
                  <Link
                    key={category.id}
                    to={`/products?category_id=${category.id}`}
                    className=" text-decoration-none"
                  >
                    <div className=" flex flex-col mx-2 max-sm:my-4 ">
                      <img
                        src={category.image}
                        alt={category.name}
                        className=" object-cover rounded-md transition-transform duration-300 w-44 h-40 2xl:w-60 2xl:h-52 group-hover:scale-110 max-lg:h-28 max-sm:h-44 max-sm:w-64 "
                      />
                      <p className="text-center text-sm text-[#371400] mt-2 2xl:text-base">
                        {category.name}
                      </p>
                    </div>
                  </Link>
                ))
              ) : (
                <p>No categories found</p>
              )}
            </div>
          </div>
        </section>
  
        {!isSeller ? (
          <section className="recent-products pt-5 mt-4 py-10 w-full mx-auto">
            <div className="tool-container mx-auto w-[90%]">
              <div className="flex justify-between items-center">
                <h2 className="text-xl sm:text-xl font-medium">Find Your Tool</h2>
                <Link to="/products" className="text-black text-sm underline">
                  View more
                </Link>
              </div>
              <hr className="my-4" />
              <div className='bg-gray-200 p-5'>
                <div className="swiper-container   items-center flex">
                  <div className="w-[100%]">
                    {loading ? (
                      <p>Loading products...</p>
                    ) : products.length > 0 ? (
                      <Swiper
                        navigation={true}
                        modules={[Autoplay]}
                        autoplay={{ delay: 3000, disableOnInteraction: false, pauseOnMouseEnter: true }}
                        loop={true}
                        className=""
                        style={{
                          "--swiper-navigation-color": "gray",
                          "--swiper-navigation-size": "30px",
                        }}
                        breakpoints={{
                          425: {
                            slidesPerView: 1,
                          },
                          640: {
                            slidesPerView: 2,
                          },
                          768: {
                            slidesPerView: 3,
                          },
                          1024: {
                            slidesPerView: 4,
                          },
                          1440: {
                            slidesPerView: 5,
                          },
                        }}
                      >
                        {products.map((product) => (
                          <SwiperSlide key={product.id} className='swiperSlide py-2 '>
                            <div className="hover:scale-105 transition-transform duration-300 w-48 mx-auto relative group cursor-pointer max-lg:w-48 max-xl:w-48 max-2xl:w-52 ">
                              <div className="relative">
                                <img
                                  src={product.product_images[0].image}
                                  alt={product.name}
                                  className="w-full h-56 object-cover shadow-lg rounded-lg mb-4 cursor-pointer max-lg:h-48 max-2xl:h-52"
                                  onClick={() => handleProductClick(product.id)}
                                />
                                {userRole === "buyer" && (
                                  <div onClick={() => handleFavoritesClick(product.id)}>
                                    {favoriteProducts.includes(product.id) ? (
                                      <Favorite className="fav-icon absolute right-2 top-2 p-[1%] z-20 rounded-full bg-white text-red-500" />
                                    ) : (
                                      <FavoriteBorderOutlined className="invisible fav-icon absolute right-2 top-2 p-[1%] z-20 rounded-full bg-white hover:bg-sky-700 hover:text-white group-hover:visible" />
                                    )}
                                  </div>
                                )}
                                <div
                                  className="add-cart-btn w-[80%] m-0 invisible text-center text-sm p-[1.5%] absolute bottom-1 left-6 border border-gray-300 z-10 mx-auto bg-white rounded-sm shadow-2xl font-medium hover:text-white hover:bg-amber-950 group-hover:visible hover:border-none"
                                  // onClick={() => handleProductClick(product.id)}
                                  onClick={() => addtoCart(product)}
                                >
                                  Add to cart
                                </div>
                              </div>
                              <div className="bottom px-2">
                                <div className='flex flex-col justify-between text-center	'>
                                  <span className="text-base truncate text-amber-950 group-hover:font-medium" onClick={() => handleProductClick(product.id)}>
                                    {product.name}
                                  </span>
                                  <span className="text-base font-bold mt-1">
                                    Rs. {product.product_variants[0].discounted_price}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    ) : (
                      <p>No products found</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : null}
  
        {isSeller ? (
          <>
            <section className="recent-buyers pt-5 mt-4 py-10 w-full mx-auto">
              <div className="tool-container mx-auto w-[90%]">
                <div className="flex justify-between items-center">
                  <h2 className="text-xl sm:text-xl font-medium">Recent Buyers</h2>
                  <Link to="/" className="text-black text-sm underline">
                    View more
                  </Link>
                </div>
                <hr className="my-4" />
                <div className="swiper-container bg-gray-100 py-2 items-center flex">
                  <div className="w-full overflow-x-hidden">
                    {loading ? (
                      <p>Loading recent buyers...</p>
                    ) : recentBuyers.length > 0 ? (
                      <Swiper
                        navigation={true}
                        modules={[Autoplay]}
                        autoplay={{ delay: 3000, disableOnInteraction: false, pauseOnMouseEnter: true }}
                        loop={true}
                        className=""
                        style={{
                          "--swiper-navigation-color": "gray",
                          "--swiper-navigation-size": "30px",
                        }}
                        breakpoints={{
                          425: {
                            slidesPerView: 1,
                          },
                          640: {
                            slidesPerView: 2,
                          },
                          768: {
                            slidesPerView: 3,
                          },
                          1024: {
                            slidesPerView: 4,
                          },
                          1440: {
                            slidesPerView: 5,
                          },
                        }}
                      >
                        {recentBuyers.map((buyer) => (
                          <SwiperSlide key={buyer.id} className='swiperSlide py-2 '>
                            <div className="hover:scale-105 transition-transform duration-300 px-1 w-64 mx-auto relative group cursor-pointer max-lg:w-48 max-xl:w-48 max-2xl:w-52 ">
                              <div className="relative">
                                <img
                                  src={buyer.product_images && buyer.product_images.length > 0 ? buyer.product_images[0].image : 'fallback-image-url.jpg'}
                                  alt={buyer.name}
                                  className="w-full h-56 object-cover shadow-lg rounded-lg mb-4 cursor-pointer max-lg:h-48 max-2xl:h-52"
                                  onClick={() => handleProductClick(buyer.id)}
                                />
                                <div
                                  className="add-cart-btn w-[80%] m-0 invisible text-center text-sm p-[1.5%] absolute bottom-1 left-6 border border-gray-300 z-10 mx-auto bg-white rounded-sm shadow-2xl font-medium hover:text-white hover:bg-amber-950 group-hover:visible hover:border-none"
                                  onClick={() => navigate(`/buyers-details/${buyer.id}`)}
                                >
                                  View Details
                                </div>
                              </div>
                              <div className="bottom px-2">
                                <div className='flex flex-col justify-between text-center'>
                                  <span className="text-base truncate text-amber-950 group-hover:font-medium" onClick={() => handleProductClick(buyer.id)}>
                                    {buyer.product_name}
                                  </span>
                                  <span className="text-base font-bold mt-1">
                                    Rs. {buyer.product_variant_discounted_price}
                                  </span>
                                </div>
                                <hr />
                                <div className="buyersName text-amber-950 font-semibold justify-between text-center">{buyer.name}</div>
                              </div>
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    ) : (
                      <div className="w-full h-[300px] flex items-center justify-center bg-red-50">
                        <p className="text-lg text-gray-600">recent buyers not found</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
  
            <section className="recent-orders pt-5 mt-4 py-10 w-full mx-auto">
              <div className="recent-order-container w-[90%] mx-auto">
                <div className="justify-between items-center">
                  <h2 className="text-xl font-medium">Recent Orders</h2>
                  <hr className="my-4" />
                </div>
                <div className="recent-feeds grid grid-cols-2 max-lg:grid-cols-1 max-lg:mx-auto">
                  {loading ? (
                    <p>Loading recent orders...</p>
                  ) : recentOrders.length > 0 ? (
                    recentOrders.map((order) => (
                      <div key={order.id} className="feed flex bg-red-50 w-[95%] mb-5 rounded-xl shadow-lg">
                        <div className="left h-44 w-52 rounded-l-lg">
                          <img src={order.product_images && order.product_images.length > 0 ? order.product_images[0].image : "assets/spareparts.jpg"} alt="img" className='h-44 w-full rounded-l-lg cursor-pointer' />
                        </div>
                        <div className="right ml-2 p-3 flex flex-col w-[75%] justify-between">
                          <div className="top">
                            <div className="title text-amber-950 text-lg font-bold mb-2 cursor-pointer">{order.product_name}</div>
                            <div className="orderid text-amber-950">{order.order_id}</div>
                          </div>
                          <div className="data flex justify-between w-full max-sm:flex-col">
                            <div className="k">{order.order_status_date && formatDate(order.order_status_date)}</div>
                            <div className="k cursor-pointer flex items-center max-sm:justify-end">
                              <span className="k font-semibold">Order Details</span>
                              <span className="k ml-1 text-2xl font-bold">{">"}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="w-full h-[300px] flex items-center justify-center bg-red-50">
                      <p className="text-lg text-gray-600">recent orders not found</p>
                    </div>
                  )}
                </div>
              </div>
            </section>
  
            <section className="recent-product pt-5 mt-4 py-10 w-full mx-auto">
              <div className="recent-products-container w-[90%] mx-auto">
                <div className="justify-between items-center">
                  <h2 className="text-xl font-medium">Recent Products</h2>
                  <hr className="my-4" />
                </div>
                <div className="k flex justify-between flex-wrap gap-4 max-sm:flex-col max-sm:items-center">
                  {loading ? (
                    <p>Loading recent products...</p>
                  ) : recentProductsData.length > 0 ? (
                    recentProductsData.map((product) => (
                      <div 
                        key={product.id} 
                        className="product-tile flex flex-col items-center mx-1 max-sm:mx-auto w-full md:w-[230px] h-[250px]"
                      >
                        <img 
                          src={product.product_images[0].image}
                          alt={product.name} 
                          className="w-full h-[150px] object-cover rounded-lg cursor-pointer"
                          onClick={() => handleProductClick(product.id)}
                        />
                        <div className="product-name text-center text-amber-950 font-semibold text-lg mt-2">
                          {product.name}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="w-full h-[300px] flex items-center justify-center bg-red-50">
                      <p className="text-lg text-gray-600">recent products not found</p>
                    </div>
                  )}
                </div>
              </div>
            </section>
          </>
        ) : null}       
  
      </div>
      <div className='w-full h-[2000px] max-sm:h-[2500px] max-xl:h-[1400px] max-2xl:h-[1450px] rounded-bl-[2%] rounded-br-[2%]'>
        {/* <iframe src="https://tsofie.com/" className='w-full h-[1610px] max-sm:h-[2900px] max-xl:h-[2000px] rounded-bl-[2%] rounded-br-[2%]'>
        </iframe> */}
      <HomeContent/>
      </div> 
      <div className="home-footer">
        <Footer />
      </div>
       {loading?<div className='fixed inset-0 z-50 bg-gray-200 bg-opacity-50 flex justify-center items-center'>
                    <Oval
                    visible={true}
                    height="80"
                    width="80"
                    color="#995500"
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    secondaryColor='none'
                    strokeWidth={3}
                    />
                    </div>:""}
    </>
  );
}
